/**
 * @description Функция определяющая по регуляке является ли урл странице Nextjs раскаченной в проде без условий и АБ тестов.
 * Получить список урлов можно в табличке https://docs.litres.ru/pages/viewpage.action?pageId=137888623
 * @return true в случае если страница Nextjs, в противном случае false
 * @param href string - урл
 *
 */
export const isNextJSDestinationEnv = (href?: string) => {
  if (!href) {
    return false;
  }

  const regexpArr = [
    //главная страница
    /^\/$/gm,
    // страница жанров
    /^\/genre\//gm,
    //корневая страница списка жанров
    /^\/pages\/new_genres\/$/gm,
    // страница новинок
    /^\/new\/$/gm,
    //страница популярного
    /^\/popular\/$/gm,
    //карточка книги за исключением сабдоменов otzivi, citat, citatya, pohozhie
    /^(\/book\/|\/podcast\/|\/audiobook\/)(?!.*(\/(citaty|citata|pohozhie))\/)/gm,
    //страница поиска
    /^\/search\//gm,
    //выбор редакции
    /^\/vibor-redaktsii\/$/gm,
    // страница автора
    /(\/author\/)/gm,
    // страницы коллекций
    /^(\/collections\/)/gm,
    // витрина черновиков
    /^\/drafts\/$/gm,
    // витрина комиксов
    /^\/comics\/$/gm,
    // витрина аудиокниг
    /^\/audiobooks\/$/gm,
    // витрина эксклюзивов
    /^\/selfpublishing\/$/gm,
    // витрина подкастов
    /^\/podcasts\/$/gm,
    //мои книги
    /^\/my-books\/$|\/my-books\/(?=cloud\/$|cart\/$|library\/$|purchased\/$|read-and-listen\/$|archived\/$|(shelfs\/(\d+)?)|campaigns\/$|liked\/$|my-authors\/$)/gm,
    // страница сертификатов
    /^\/certificate-present\/$/gm,
    //страница мобильных приложений
    /^\/app\/$/gm,
    //журнал
    /^\/journal\//gm,
    //лендинг
    /^\/landings\//gm,
    /^\/litres_subscription\/$/gm,
    //платежный фрейм
    /^\/payment\/(ppd|subscription|proceed|success|error)\//gm,
    //тэги
    /^\/tags\//gm,
    //серии
    /^\/series\//gm,
    //рекомендации
    /^\/recommended\//gm,
    /^\/recommend\/$/gm,
    //страница вакансий
    /^\/company\/vacancies\//gm,
    // профиль
    /^\/me\//gm,
    //лэндинг библиотек
    /^\/pages\/libhouse_map\/$/gm,
    // опрос при уходи из подписки
    /^\/subscription-cancel-survey\//gm,
    // страница конструкора лендингов
    /^\/landing\//gm,
    /^\/pages\/2024-year-in-review\//gm,
  ];

  return regexpArr.some(regexp => regexp.test(href));
};
